import * as React from 'react';
import { KeyboardEvent, KeyboardEventHandler, MouseEvent, MouseEventHandler, TouchEvent, TouchEventHandler } from 'react';

type useIsActiveProps = {
    disabled: boolean,
    onKeyDown?: KeyboardEventHandler,
    onKeyUp?: KeyboardEventHandler,
    onMouseDown?: MouseEventHandler,
    onMouseUp?: MouseEventHandler,
    onTouchStart?: TouchEventHandler,
    onTouchEnd?: TouchEventHandler
}

export const useIsActive = ({
    disabled=false,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseUp,
    onTouchStart,
    onTouchEnd
}: useIsActiveProps) => {

    const [isActive, setIsActive] = React.useState(false);

    const isHTMLAnchor = (currentTarget: any) => {
      let isAnchor = false;

      if(currentTarget && currentTarget instanceof HTMLAnchorElement) {
        isAnchor = true;
      }

      return isAnchor;
    }

    let isActiveProps = {
      onKeyDown(e:KeyboardEvent) {
        if(!disabled) {
          if (!isHTMLAnchor(e?.currentTarget) && (e?.key === 'Enter' || e?.key === 'Space')) {
            setIsActive(true);
          }

          if(onKeyDown) {
            onKeyDown(e);
          }
        }
      },
      onKeyUp(e:KeyboardEvent) {
        if(!disabled) {
          if(isActive) {
            setIsActive(false);
          }

          if(onKeyUp) {
            onKeyUp(e);
          }
        }
      },
      onMouseDown(e:MouseEvent) {
        if(!disabled) {
          setIsActive(true);

          if(onMouseDown) {
            onMouseDown(e);
          }
        }
      },
      onMouseUp(e:MouseEvent) {
        if(!disabled) {
          if(isActive) {
            setIsActive(false);
          }

          if(onMouseUp) {
            onMouseUp(e);
          }
        }
      },
      onTouchStart(e:TouchEvent) {
        if(!disabled) {
          setIsActive(true);

          if(onTouchStart) {
            onTouchStart(e);
          }
        }
      },
      onTouchEnd(e:TouchEvent) {
        if(!disabled) {
          if(isActive) {
            setIsActive(false);
          }

          if(onTouchEnd) {
            onTouchEnd(e);
          }
        }
      },
    };
      
    return {isActiveProps, isActive};
};

